import { Navigate, Outlet, createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/projects/$projectId/workspace')({
  component: WorkspaceRoute,
});

/**
 * T224 — parent route for the workspace tabs.
 *
 * File-based routing makes this the LAYOUT PARENT of `workspace.$tab`, so it MUST
 * render <Outlet/> or the active tab never mounts. Previously this rendered a bare
 * <Navigate> with no <Outlet/>, which swallowed every tab: visiting
 * /projects/$id/workspace/overview matched the parent, redirected to the same URL,
 * and rendered null → a blank white workspace page (no tab, no project fetch, no error).
 *
 * The bare /projects/$id/workspace path (no tab segment) still redirects to overview:
 * loose useParams merges the active match chain, so `tab` is present only when the
 * $tab child is matched; its absence means we're on the bare parent path.
 */
function WorkspaceRoute() {
  const { projectId, tab } = useParams({ strict: false }) as { projectId?: string; tab?: string };

  if (projectId && !tab) {
    return (
      <Navigate
        to="/projects/$projectId/workspace/$tab"
        params={{ projectId, tab: 'overview' }}
        replace
      />
    );
  }

  return <Outlet />;
}
